import { TenantEntity } from '../TenantEntity'

export class FlightDescription extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FlightDescription'
  }
  get flightNo() {
    return this._data.flightNo
  }
  set flightNo(flightNo) {
    this._data.flightNo = flightNo
  }
  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }
  get loadingPortCode() {
    return this._data.loadingPortCode
  }
  set loadingPortCode(loadingPortCode) {
    this._data.loadingPortCode = loadingPortCode
  }
  get destinationPortCode() {
    return this._data.destinationPortCode
  }
  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode
  }
  get beginValidDate() {
    return this._data.beginValidDate
  }
  set beginValidDate(beginValidDate) {
    this._data.beginValidDate = beginValidDate
  }
  get endValidDate() {
    return this._data.endValidDate
  }
  set endValidDate(endValidDate) {
    this._data.endValidDate = endValidDate
  }
  get createDepartment() {
    return this._data.createDepartment
  }
  set createDepartment(createDepartment) {
    this._data.createDepartment = createDepartment || 0
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get cargoTerminals() {
    return this._data.cargoTerminals
  }
  set cargoTerminals(cargoTerminals) {
    this._data.cargoTerminals = cargoTerminals
  }
  get airplaneModel() {
    return this._data.airplaneModel
  }
  set airplaneModel(airplaneModel) {
    this._data.airplaneModel = airplaneModel
  }
  get charterFlightOrCharterVessel() {
    return this._data.charterFlightOrCharterVessel
  }
  set charterFlightOrCharterVessel(charterFlightOrCharterVessel) {
    this._data.charterFlightOrCharterVessel = charterFlightOrCharterVessel || 0
  }
}
